export function isNotNull(obj) {
    return typeof (obj) != undefined && obj != null;
}

export function isNull(obj) {
    return !isNotNull(obj)
}

export function stringDataFormatoJava(dt) {
    const pad = n => String(n).padStart(2, '0');

    const y = dt.getFullYear();
    const m = pad(dt.getMonth() + 1);
    const d = pad(dt.getDate());
    const h = pad(dt.getHours());
    const min = pad(dt.getMinutes());
    const s = pad(dt.getSeconds());

    return `${y}-${m}-${d}T${h}:${min}:${s}`;
}

export function formatDateComHorasEhMinutos(date) {

    if (typeof (date) == "string") {
        date = new Date(date)
    }

    var dia = date.getDate()
    var mes = date.getMonth() + 1
    var ano = date.getFullYear()

    if (dia < 10) dia = "0" + dia
    if (mes < 10) mes = "0" + mes

    var horas = date.getHours()
    var minutos = date.getMinutes()
    var segundos = date.getSeconds();

    if (horas < 10) horas = "0" + horas
    if (minutos < 10) minutos = "0" + minutos

    var texto = (ano.toString().substring(2, 4)) + "/" + mes + "/" + dia + " - " + horas + ":" + minutos + ":" + segundos

    return texto
}

export function formatDateComHoras(date) {

    if (typeof (date) == "string") {
        date = new Date(date)
    }

    var dia = date.getDate()
    var mes = date.getMonth() + 1
    var ano = date.getFullYear()

    if (dia < 10) dia = "0" + dia
    if (mes < 10) mes = "0" + mes

    var horas = date.getHours()
    var minutos = date.getMinutes()
    var segundos = date.se

    if (horas < 10) horas = "0" + horas
    if (minutos < 10) minutos = "0" + minutos

    var texto = (ano.toString().substring(2, 4)) + "/" + mes + "/" + dia + " - " + horas + ":" + minutos

    return texto
}

export function formatDateComHorasSomente(date) {

    if (typeof (date) == "string") {
        date = new Date(date)
    }

    var dia = date.getDate()
    var mes = date.getMonth() + 1
    var ano = date.getFullYear()

    if (dia < 10) dia = "0" + dia
    if (mes < 10) mes = "0" + mes

    var horas = date.getHours()
    // var minutos = date.getMinutes()
    // var segundos = date.se

    if (horas < 10) horas = "0" + horas
    // if(minutos < 10) minutos = "0" + minutos

    var texto = (ano.toString().substring(2, 4)) + "/" + mes + "/" + dia + "-" + horas

    return texto
}

export function formatDateSemHoras(date) {

    if (typeof (date) == "string") {
        date = new Date(date)
    }

    var dia = date.getDate()
    var mes = date.getMonth() + 1
    var ano = date.getFullYear()

    if (dia < 10) dia = "0" + dia
    if (mes < 10) mes = "0" + mes

    var texto = (ano.toString().substring(2, 4)) + "/" + mes + "/" + dia
    return texto
}

export function formatDateJavaComHoras(string) {
    return formatDateComHoras(new Date(string))
}

export function formataTimeDeMilli(millis) {
    if (millis < 1000) return millis + "ms"
    if (millis < 60000) return (millis / 1000).toFixed(2) + "s"
    return (millis / 60000).toFixed(2) + "m"
}

export function formataTamahoDeBytes(tam) {

    if (tam < 1024) return tam

    tam = tam / 1024

    if (tam < 1024) return tam.toFixed(1) + "kb"

    tam = tam / 1024
    return tam.toFixed(2) + "mb"
}

export function loadingValue(flags, key) {

    if (typeof key !== "string") {
        return false
    }
    if (typeof flags !== "object") {
        return false
    }
    var value = false

    flags.forEach(e => {
        if (e.tag === key) {
            value = e.value
        }
    })

    return value

}

export function extrairTags(str) {
    return str
        .split(/\s*,\s*/g)        // separa por vírgulas
        .filter(w => w.startsWith('#') && w.length > 1);
}


export function removerElementoDoArray(arr, index) {
    return arr.filter((_, i) => i !== index);
}

export function tempoAtras(dataStr, dataAgoraServidor, f = false) {

    if (dataStr == null) return;

    const [dataParte, horaParte] = dataStr.split(' ');
    const [ano, mes, dia] = dataParte.split('-').map(Number);
    const [hora, minuto, segundo] = horaParte.split(':').map(Number);

    // Cria data UTC equivalente ao horário de São Paulo (UTC-3)
    const data = new Date(Date.UTC(ano, mes, dia, hora, minuto, segundo));

    const [dataParteServ, horaParteServ] = dataAgoraServidor.split(' ');
    const [anoServ, mesServ, diaServ] = dataParteServ.split('-').map(Number);
    const [horaServ, minutoServ, segundoServ] = horaParteServ.split(':').map(Number);

    const dataServidor = new Date(Date.UTC(anoServ, mesServ, diaServ, horaServ, minutoServ, segundoServ));

    let diff = Math.floor((dataServidor.getTime() - data.getTime()) / 1000);

    if (f) {
        console.log(data)
        console.log(dataServidor)
        console.log(diff)
    }

    const dias = Math.floor(diff / 86400);
    diff %= 86400;

    const horas = Math.floor(diff / 3600);
    diff %= 3600;

    const minutos = Math.floor(diff / 60);
    const segundos = diff % 60;

    return [ `${dias}` + ":", `${horas}` + " ", `${minutos}` + "m ", `${segundos}` + "s"].join('') + '';
}

export function miliToMascara(tempo) {
    let diff = Math.trunc(tempo/1000);
    const dias = Math.floor(diff / 86400);
    diff %= 86400;

    const horas = Math.floor(diff / 3600);
    diff %= 3600;

    const minutos = Math.floor(diff / 60);
    const segundos = diff % 60;

    return [ `${dias}` + ":", `${horas}` + " ", `${minutos}` + "m ", `${segundos}` + "s"].join('') + '';
}
